import './style/languageToggle.scss';
import classNames from 'classnames';

import React, {useContext} from 'react';
import {Language} from '../../util/enums';
import {ContentContext} from '../context/contentContext';

export default function LanguageToggle() {
    const context = useContext(ContentContext);

    function onClickLanguage(language: Language) {
        return function () {
            if (language === context.language) return;
            context.onChangeContext({language});
            saveInStorage(language);
        };
    }

    function saveInStorage(language: Language) {
        if (!localStorage) return;
        localStorage.setItem('language', language);
    }

    function renderLanguage(language: Language) {
        const active = language === context.language;
        const title = language === Language.NL ? 'Nederlands' : 'English';
        const flag = language === Language.NL ? 'nl' : 'gb';
        return (
            <div className={classNames('language', active && 'active')} onClick={onClickLanguage(language)}>
                <span className={classNames('fi', `fi-${flag}`)}
                      title={title}/>
            </div>
        );
    }

    return (
        <div className='language-toggle'>
            {renderLanguage(Language.NL)}
            <div className='sep'/>
            {renderLanguage(Language.EN)}
        </div>
    );
}